// extracted by mini-css-extract-plugin
export default {"statsCard_outer":"StatsCard_statsCard_outer__t3gm5","statsCard_inner":"StatsCard_statsCard_inner__Fy1q7"};